import React from 'react'
import Homescreen from '../Components/Homescreen/Homscreen'

function Home() {
  return (
    <div>
        <Homescreen/>
    </div>
  )
}

export default Home